<!--基础课发布记录-->
<template>
  <div class="table-container" style="margin-top: 0px;">
    <el-table :data="releaseLessons" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" max-height="560" border>
      <el-table-column :label="tableTitleData.swTeacher" prop="swTeacher">
        <template slot-scope="scope">
          <el-time-picker style="width: 120px" v-model="scope.row.time" format="HH:mm" value-format="HH:mm"
            :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="时间" />
        </template>
      </el-table-column>
      <el-table-column label="业务" prop="name"></el-table-column>
      <el-table-column v-for="(titleItem, idx) in tableTitleData.time" v-bind:key="idx" :label="titleItem">
        <template slot-scope="scope">
          <el-row>
            <!-- 婴儿 -->
            <el-input readonly="true" v-model="scope.row.cn[idx][0].max" size="mini" style="width: 60px"></el-input>
            <el-button @click="onUpdateOneItem(scope.row.cn[idx][0], 1, idx, scope.row.time)" style="margin-top: 5px;"
              size="mini" icon="el-icon-mouse" circle></el-button>
          </el-row>
          <!-- <el-row>
            幼儿
            <el-input readonly="true"   v-model="scope.row.cn[idx][1].max" size="mini" style="width: 60px"></el-input>
            <el-button @click="onUpdateOneItem(scope.row.cn[idx][1],2, idx, scope.row.time)"  style="margin-top: 5px;"  size="mini" icon="el-icon-mouse" circle></el-button>
          </el-row> -->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="修改课程" :visible.sync="visibleDlgUpdate" width="50%" center>
      <el-form ref="registerRef" label-width="150px">
        <el-form-item label="课容量:">
          <el-input-number v-model="updateParam.maxBookPeople"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doUpdateOneItem">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.table-container {
  border: 0px;
}

/deep/ .el-table th.el-table__cell>.cell {
  /* width: 99%; */
  /* height: auto; */
  background: #ecf3fd;
  /* border-radius: 8px; */
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 60px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  /* border: 2px solid #d0d0d0; */
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  text-align: left;
  /* border-radius: 10px;
background: #f0f7ff; */
}

/deep/ .el-table .el-table__cell {
  padding: 0px;
}

/deep/ .el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 12px 0;
}
</style>

<script>

import enumsUtil from "../../../../utils/enumsUtil";
import timeUtils from "../../../../utils/timeUtils";
import globaldata from "../../../../utils/globaldata";
import { qlDayReleaseLessons, qlWeekReleaseLessons, updateOneBsLesson } from "../../../../api/StoreReleaseLesson";
import commonUtils from "../../../../utils/commonUtils";
import { formatDate } from "../../../../utils/date";
import messageUtils from "../../../../utils/messageUtils";

export default {
  name: 'SchelingBaseReleaseRecords',
  props: {
    day: Number, //时间戳
  },
  data() {
    return {
      visibleDlgUpdate: false,
      tableTitleData: {
        swTeacher: "时间(时:分)",
        time: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      },

      tableData: [
      ],
      addItemParam: [],

      //查询出来的已经发布的课程
      releaseLessons: [
        {
          time: "00:00",
          //一周这个时间点的课程 第一个为婴儿  第二个为幼儿
          cn: [
            [{ id: 0, max: 0 }, { id: 0, max: 0 }],
            [{ id: 0, max: 0 }, { id: 0, max: 0 }],
            [{ id: 0, max: 0 }, { id: 0, max: 0 }],
            [{ id: 0, max: 0 }, { id: 0, max: 0 }],
            [{ id: 0, max: 0 }, { id: 0, max: 0 }],
            [{ id: 0, max: 0 }, { id: 0, max: 0 }],
            [{ id: 0, max: 0 }, { id: 0, max: 0 }],
          ]
        },

      ],

      updateParam: ""

    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.resetAddOne();
      this.qlDayReleaseLessons()
    },
    resetAddOne() {
      this.addItemParam = {
        time: "00:00", //时间
        //孩子数量
        cn: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ]

      }
    },




    onGetBaseTime() {
      return this.tableData;
    },
    qlDayReleaseLessons() {

      let dayTime = new Date();
      if (!commonUtils.isObjectNull(dayTime)) {
        dayTime.setTime(this.day);
      }

      dayTime = formatDate(dayTime, "yyyy-MM-dd")
      let param = {
        dayTime: dayTime,
        lessonTemplateId: enumsUtil.lessonTemplateIdBS(),
        storeFrontId: globaldata.getAdminStore().storeFrontId
      }

      qlWeekReleaseLessons(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }

        this.alalysisReleaseLessons(data, new Date(dayTime));
      })

    },
    //将发布的课程转换页面数据
    alalysisReleaseLessons(list, searchDate) {
      let fdds=[]
      list.forEach((item, index) => {
        if(index != 0){
          if (index%6 == 0) {
          
          fdds.push(item.name)
        }
        }
      })
      this.releaseLessons = [];
      if (commonUtils.isArrayNull(list)) {
        return;
      }
      //所有上课的时间
      let timeMap = new Map();
      //1.获取所有课程的上课时间
      for (let i = 0; i < list.length; ++i) {
        let lesson = list[i];
        let classStartTime = lesson.classStartTime;

        timeMap.set(classStartTime, 1)
      }
      let timeList = []
      timeMap.forEach(function (_value, key) {
        timeList.push(key);

      });
      let monday = timeUtils.getFirstDayOfWeek(searchDate); //周一

      //将 timeList 从小到大排序
      timeList.sort(function (a, b) {
        return a - b
      });

      //按照时间将课程初始化
      for (let i = 0; i < timeList.length; ++i) {
        let classStartTime = timeList[i];
        let cn = [];
        for (let i = 0; i < 7; ++i) {
          cn.push([{ id: null, max: 0 }, { id: null, max: 0 }])
        }
        let lessonItem = {
          time: timeUtils.transTimeHM(classStartTime),
          cn: cn,
          name:fdds[i]
        }
        this.releaseLessons.push(lessonItem)
      }

      //将查询到的课程通过时间 一一对应

      for (let i = 0; i < list.length; ++i) {

        let lesson = list[i];
        let classStartTime = lesson.classStartTime;
        let id = list[i].id; //课程id
        let dayTime = list[i].dayTime;//上课日期
        let classStartTimeStr = timeUtils.transTimeHM(classStartTime);
        let classStartMonth = list[i].startMonth; //起始月龄
        let maxBookPeople = list[i].maxBookPeople; //课程最大预约数

        for (let j = 0; j < this.releaseLessons.length; ++j) {
          let time = this.releaseLessons[j].time;
          let cn = this.releaseLessons[j].cn;     //上课时间对应的一周课程
          if (time == classStartTimeStr) {

            //时间相同 就在同一行 ,接下来是找周几的,也就是cn对应的索引
            let classDay = timeUtils.transDay(dayTime);


            //获取相差天数
            let index = timeUtils.getDaysBetween2(monday, classDay);


            if (index < 7 && index >= 0) {
              if (classStartMonth <= 0) {
                //婴儿
                cn[index][0].id = id;
                cn[index][0].max = maxBookPeople;
              } else {
                //幼儿
                cn[index][1].id = id;
                cn[index][1].max = maxBookPeople;
              }
            }
          }
        }



      }

    },


    /**
     * 修改某个课程
     * @param index
     * weekIndex :周几的索引
     * time:上课时间
     */
    onUpdateOneItem(cn, childType, weekIndex, time) {

      let dayTime = new Date();
      dayTime.setTime(this.day);
      let monday = timeUtils.getFirstDayOfWeek(dayTime).getTime();

      dayTime = monday + timeUtils.getDayMs() * weekIndex

      let param = {
        id: cn.id,
        childType: childType,
        maxBookPeople: cn.max,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        releaseAdminId: globaldata.getAdminStore().id,
        classStartTime: timeUtils.transTimeHMInt(time),
        dayTime: dayTime

      }
      this.updateParam = param;
      this.visibleDlgUpdate = true;
      // console.log("onUpdateOneItem",cn,childType,weekIndex,time,param)


    },
    doUpdateOneItem() {
      let param = this.updateParam;

      updateOneBsLesson(param).then(response => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          this.visibleDlgUpdate = false;
          messageUtils.successMsg(this, response.message);
          this.initData();
        } else {
          messageUtils.errorMsg(this, response.message);
        }


      })
    }


  }
}
</script>






// WEBPACK FOOTER //
// src/views/my-store/sw-teacher-scheduling-bs/components/SchelingBaseReleaseRecords.vue